import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ListIcon, TargetIcon, CalendarIcon, CheckSquareIcon } from 'lucide-react';
const contents = [{
  icon: FileTextIcon,
  title: 'Diagnóstico claro',
  description: 'Para identificar tu patrón específico de scroll'
}, {
  icon: ListIcon,
  title: 'Lista de 7 gatillos',
  description: 'Cómo detectarlos antes de que te ganen'
}, {
  icon: TargetIcon,
  title: 'Fricción física y digital',
  description: 'Parking del teléfono, zonas, rituales, notificaciones, grises, home screen, bloqueos'
}, {
  icon: RefreshCwIcon,
  title: 'Reemplazos por emoción',
  description: 'Estrategias específicas para ansiedad, aburrimiento, frustración, cansancio'
}, {
  icon: CalendarIcon,
  title: 'Protocolo 3–7–15',
  description: 'Para cortar recaídas sin culpa y volver rápido'
}, {
  icon: CheckSquareIcon,
  title: 'Setup de estudio',
  description: 'Sin teléfono + breaks limpios que sí funcionan'
}, {
  icon: CalendarIcon,
  title: 'Plan día por día',
  description: '7 días de implementación guiada paso a paso'
}, {
  icon: FileTextIcon,
  title: 'Plantillas imprimibles',
  description: 'Tracker + checklist + lista de reemplazos'
}];
function RefreshCwIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-134">
      <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" data-id="element-135" />
      <path d="M21 3v5h-5" data-id="element-136" />
      <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" data-id="element-137" />
      <path d="M8 16H3v5" data-id="element-138" />
    </svg>;
}
export function IncludedSection() {
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-139">
      <div className="max-w-6xl mx-auto" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-141">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mb-6" data-id="element-142">
            Qué incluye el <span className="text-teal" data-id="element-143">PDF</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-144">
          {contents.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-gray-50 rounded-xl p-6 border-2 border-gray-200 hover:border-teal hover:shadow-lg transition-all duration-300" data-id="element-145">
                <div className="bg-teal/10 w-12 h-12 rounded-lg flex items-center justify-center mb-4" data-id="element-146">
                  <Icon className="w-6 h-6 text-teal" aria-hidden="true" data-id="element-147" />
                </div>
                <h3 className="text-lg font-bold text-navy mb-2" data-id="element-148">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-149">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}